export default {
  to: "/profile",
  order: 4,
  icon: "mdi-account-details",
  title: "My Profile",
  disabled: false,
  sublinks: [
    // {
    //   to: "/profile/bio",
    //   icon: "mdi-account-circle",
    //   title: "Bio",
    //   disabled: false,
    //   value: 0,
    // },
    {
      to: "/profile/contact",
      icon: "mdi-card-account-phone",
      title: "Contact",
      disabled: false,
      value: 0,
    },
    {
      to: "/profile/academic",
      icon: "mdi-book-open",
      title: "Academic",
      disabled: false,
      value: 0,
    },
    {
      to: "/profile/experience",
      icon: "mdi-account-hard-hat",
      title: "Experience",
      disabled: false,
      value: 0,
    },
    {
      to: "/profile/referee",
      icon: "mdi-account-supervisor",
      title: "Referees",
      disabled: false,
      value: 0,
    },
    // {
    //   to: "/profile/specialization",
    //   icon: "business_center",
    //   title: "Specialization",
    //   disabled: false,
    //   value: 0,
    // },
    {
      to: "/profile/admission-letter",
      icon: " mdi-script",
      title: "Admission Letter",
      disabled: false,
      value: 0,
    },
  ],
};
